
import { Contract } from "../../customProvider/objects/contract";
import { CustomProvider } from "../../customProvider/objects/customProvider";
import { DestinationReduced } from "../../destination/objects/destinationReduced";
import { MarketView } from "../../marketView/objects/marketView";
import { Author } from "../../user/objects/author";
import { User } from "../../user/objects/user";
import { Segment } from "./Segment";
import { TransferMarketType } from "./transferMarket";
import { TransferPrice } from "./transferPrice";
import { VehicleModel } from "./vehicleModel";

export interface PriceModel {
    id: number;
    last_author: Author | number;
    creator: Author | number;
    created_date?: Date;
    modified_date?: Date;
    name: string;
    // t('model-price.AGE')
    variable: ("AGE" | "DISTANCE" | "DURATION" | "NUMBER_OF_PERSONS" | "NUMBER_OF_PERSONS_PRICE" | 'NUMBER_OF_PRODUCTS')[];
    deactivated: boolean;
    owner: number;
    localization: { name: string }[];
}

export interface PriceValue {
    id?: number;
    variable: "AGE" | "DISTANCE" | "DURATION" | "NUMBER_OF_PERSONS" | "NUMBER_OF_PERSONS_PRICE" | 'NUMBER_OF_PRODUCTS';
    value: (string | number)[];
    value_error: string[]
}
export interface TransferLocalized {
    locale: number;
    title: string;
    description?: string;
    voucher_remark?: string;
    pick_up_info?: string;
}

export enum BookingEngine {
    "CIRCUIT" = "CIRCUIT",
    "TAILOR_MADE" = "TAILOR_MADE",
    "FLIGHT" = "FLIGHT"
}

export enum VehicleTransferBasicDataProductTypeValue {
    'ECONOMY' = 'ECONOMY',
    'STANDARD' = 'STANDARD',
    'EXPRESS' = 'EXPRESS',
    'SPECIAL' = 'SPECIAL',
    'PREMIUM' = 'PREMIUM',
    'LUXURY' = 'LUXURY',
}
export enum VehicleTransferBasicDataServiceTypeValue {
    'PRIVATE' = 'PRIVATE',
    'SHUTTLE' = 'SHUTTLE',
    'SHARED' = 'SHARED',
}
export enum DaysString {
    MONDAY = 'Monday',
    TUESDAY = 'Tuesday',
    WEDNESDAY = 'Wednesday',
    THURSDAY = 'Thursday',
    FRIDAY = 'Friday',
    SATURDAY = 'Saturday',
    SUNDAY = 'Sunday',
}
export enum OperationalOpenType {
    'ALL_DAYS' = 'ALL_DAYS',
    'SPECIFIC_DAYS' = 'SPECIFIC_DAYS',
}

export interface VehicleTransferBasicDataScheduleTime {
    departure: string | Date | null;
    arrival: string | Date | null;
}


export interface Transfer {
    // transfer basic information
    id: number;
    is_active: boolean;
    title: string;
    description: string;
    voucher_remark: string;
    localization: TransferLocalized[];

    visibility: 'PUBLIC' | 'PRIVATE_TO' | 'PRIVATE',

    // additional transfer information
    number_of_releases: number | string;
    service_type: VehicleTransferBasicDataServiceTypeValue;
    // pickup_time_before_departure: number | string;
    transfer_in_from_transport: boolean;

    // time informations
    operational_open_type: OperationalOpenType;
    operational_days: number[];
    operational_hours: Record<Partial<DaysString>, string[]>;
    schedule_times: VehicleTransferBasicDataScheduleTime[];
    search_engines: BookingEngine[]
    end_date: Date | null;
    start_date: Date | null;


    // vehicle model
    vehicle_model: Partial<VehicleModel> | number;

    // contract data
    contracts: Contract[];
    deactivated_contracts: number[];
    providers: CustomProvider[];

    // route/segment
    segment: Segment | null;

    // price
    prices: TransferPrice[];
    // model: PriceModel | null;
    // price: string | number;
    // values: PriceValue[];
    destination: null | DestinationReduced;

    // basic class attribute
    last_author: Author | null;
    modified_date: Date;
    created_date: Date;
    creator: User | null;

    // market
    allowed_markets: MarketView[],
    market_type: TransferMarketType,
    sub_market: MarketView | null,

    exception_cms?: { id: number, name: string }[],

}
